import { render } from "./Newsletter.vue?vue&type=template&id=65d1a3be"
import script from "./Newsletter.vue?vue&type=script&lang=js"
export * from "./Newsletter.vue?vue&type=script&lang=js"

import "./Newsletter.vue?vue&type=style&index=0&id=65d1a3be&lang=css"
script.render = render

export default script